import React from "react";
import { ReportRule } from "./ReportRule";

/**
 * Closing invoice footer — muted, smaller than main commercial sections.
 * No forced title; freeform text is the closing content.
 */
export function ReportInvoiceFooterSection({ invoiceFooter, variant = "print" }) {
  const text = invoiceFooter?.text || invoiceFooter?.notes || null;
  if (!text) return null;

  const isPrint = variant === "print";
  const sectionClassName = isPrint
    ? "erp-section erp-break-avoid invoice-closing-footer"
    : "invoice-closing-footer";
  const textClassName = isPrint
    ? "erp-invoice-footer"
    : "er-invoice-footer";

  const content = (
    <>
      <ReportRule variant={variant} />
      <p className={textClassName}>{text}</p>
    </>
  );

  if (isPrint) {
    return <section className={sectionClassName}>{content}</section>;
  }

  return <div className={sectionClassName}>{content}</div>;
}
